import React, { createContext, useContext } from "react";

/**
 * Shared app props for route components. Avoids inline `() => <Page {...props} />`
 * in App.js, which creates a new component type every render and remounts pages
 * when location hash/state changes (e.g. sidebar menu toggles using href="#").
 */
export const AppPropsContext = createContext({});

const routeCache = new WeakMap();

export function createAppRoute(Component) {
  if (!Component) {
    return Component;
  }

  if (routeCache.has(Component)) {
    return routeCache.get(Component);
  }

  function AppRoute(routeProps) {
    const appProps = useContext(AppPropsContext);
    return <Component {...appProps} {...routeProps} />;
  }

  AppRoute.displayName = `AppRoute(${
    Component.displayName || Component.name || "Component"
  })`;

  routeCache.set(Component, AppRoute);
  return AppRoute;
}
